import React, { FC, useState } from 'react'
import { Edit, EditProps, useNotify, SimpleForm, Button } from 'react-admin'
import { Drawer } from 'components'

import { useSelector, useDispatch } from 'react-redux'
import * as actions from 'customReducers/courseReducer/actions'

import { FormProvider } from 'contexts/FormProvider'

import { EditForm, CreateCourseToolbar } from '../containers'
import { makeStyles } from '@material-ui/core'

import { CreateWeek } from 'modules/weeks'
import { CreateVideo } from 'modules/video'
import { CreateTag } from 'modules/tags'
import { CreateImage } from 'modules/images'
import { CreatePerson } from 'modules/persons'
import { CreateAttachment } from 'modules/attachments'
import { CreateMark } from 'modules/marks'
import { CreateStylesheet } from 'modules/stylesheet'

interface ResponseItemProps {
    id: number
    slug?: string
    path?: string
    title?: string
    type?: string
    vimeo_id?: string
}

interface CourseModuleStateProps {
    courseModule: {
      formData: object
      openAttachments: boolean
      openCommentQuestion: boolean
      openPerson: boolean
      openTag: boolean
      openVideo: boolean
      openWeeks: boolean
      openImages: boolean
      openMarks: boolean
      openStylesheets: boolean
    }
  }

export const EditCourse: FC<EditProps> = (props) => {
    const dispatch = useDispatch()
    const notify = useNotify()
    const courseModuleState = useSelector(
        (state: CourseModuleStateProps) => state.courseModule,
    )
    const [formData, setFormData] = useState([])

    const onSubmitSuccess = (data?: ResponseItemProps) => {
        notify('post_successfully')
    }

    const onSubmitFailure = (data?: ResponseItemProps) => {
        notify('post_failed', 'warning')
    }

    const useStyles = makeStyles({
        container: {
            width: '100%',
        },
        formContainer: {
            backgroundColor: '#F5F5F5',
        },
        paperContainer: {
            padding: 16,
        },
        buttonsContainer: {
            padding: 8,
        },
        contentPaddingBottom: {
            marginBottom: 12,
        },
        contentPaddingTop: {
            marginTop: 12,
        }
    })

    const classes = useStyles()

    return (
        <>
          <Drawer open={courseModuleState.openWeeks} anchor="right">
              <CreateWeek
                {...props}
                shouldRedirect={false}
                showAside={false}
                onSubmitSuccess={(data: ResponseItemProps) =>
                  dispatch(actions.weeksDialog())
                }
                onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
                closeDrawer={
                  <Button
                    label="Cancelar"
                    redirect={false}
                    submitOnEnter={false}
                    variant="text"
                    onClick={() => dispatch(actions.weeksDialog())}
                  />
                }
              />
            </Drawer>

            <Drawer open={courseModuleState.openVideo} anchor="right">
              <CreateVideo
                {...props}
                shouldRedirect={false}
                showAside={false}
                onSubmitSuccess={(data: ResponseItemProps) =>
                  dispatch(actions.videosDialog())
                }
                onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
                closeDrawer={
                  <Button
                    label="Cancelar"
                    redirect={false}
                    submitOnEnter={false}
                    variant="text"
                    color="primary"
                    onClick={() => dispatch(actions.videosDialog())}
                  />
                }
              />
            </Drawer>

            <Drawer open={courseModuleState.openTag} anchor="right">
              <CreateTag
                {...props}
                shouldRedirect={false}
                showAside={false}
                onSubmitSuccess={(data: ResponseItemProps) =>
                  dispatch(actions.tagsDialog())
                }
                onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
                closeDrawer={
                  <Button
                    label="Cancelar"
                    redirect={false}
                    submitOnEnter={false}
                    variant="text"
                    color="primary"
                    onClick={() => dispatch(actions.tagsDialog())}
                  />
                }
              />
            </Drawer>

            <Drawer open={courseModuleState.openImages} anchor="right">
              <CreateImage
                {...props}
                shouldRedirect={false}
                showAside={false}
                onSubmitSuccess={(data: ResponseItemProps) =>
                  dispatch(actions.imagesDialog())
                }
                onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
                closeDrawer={
                  <Button
                    label="Cancelar"
                    redirect={false}
                    submitOnEnter={false}
                    variant="text"
                    color="primary"
                    onClick={() => dispatch(actions.imagesDialog())}
                  />
                }
              />
            </Drawer>

            <Drawer open={courseModuleState.openPerson} anchor="right">
              <CreatePerson
                {...props}
                shouldRedirect={false}
                showAside={false}
                onSubmitSuccess={(data: ResponseItemProps) =>
                  dispatch(actions.personsDialog())
                }
                onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
                closeDrawer={
                  <Button
                    label="Cancelar"
                    redirect={false}
                    submitOnEnter={false}
                    variant="text"
                    color="primary"
                    onClick={() => dispatch(actions.personsDialog())}
                  />
                }
              />
            </Drawer>

            <Drawer open={courseModuleState.openAttachments} anchor="right">
              <CreateAttachment
                {...props}
                shouldRedirect={false}
                showAside={false}
                onSubmitSuccess={(data: ResponseItemProps) =>
                  dispatch(actions.attachmentsDialog())
                }
                onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
                closeDrawer={
                  <Button
                    label="Cancelar"
                    redirect={false}
                    submitOnEnter={false}
                    variant="text"
                    color="primary"
                    onClick={() => dispatch(actions.attachmentsDialog())}
                  />
                }
              />
            </Drawer>

            <Drawer open={courseModuleState.openVideo} anchor="right">
              <CreateVideo
                {...props}
                shouldRedirect={false}
                showAside={false}
                onSubmitSuccess={(data: ResponseItemProps) =>
                  dispatch(actions.videosDialog())
                }
                onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
                closeDrawer={
                  <Button
                    label="Cancelar"
                    redirect={false}
                    submitOnEnter={false}
                    variant="text"
                    color="primary"
                    onClick={() => dispatch(actions.videosDialog())}
                  />
                }
              />
            </Drawer>

            <Drawer open={courseModuleState.openStylesheets} anchor="right">
              <CreateStylesheet
                {...props}
                shouldRedirect={false}
                showAside={false}
                onSubmitSuccess={(data: ResponseItemProps) =>
                  dispatch(actions.stylesheetsDialog())
                }
                onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
                closeDrawer={
                  <Button
                    label="Cancelar"
                    redirect={false}
                    submitOnEnter={false}
                    variant="text"
                    color="primary"
                    onClick={() => dispatch(actions.stylesheetsDialog())}
                  />
                }
              />
            </Drawer>

            <Drawer open={courseModuleState.openMarks} anchor="right">
              <CreateMark
                {...props}
                shouldRedirect={false}
                showAside={false}
                onSubmitSuccess={(data: ResponseItemProps) =>
                  dispatch(actions.marksDialog())
                }
                onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
                closeDrawer={
                  <Button
                    label="Cancelar"
                    redirect={false}
                    submitOnEnter={false}
                    variant="text"
                    color="primary"
                    onClick={() => dispatch(actions.marksDialog())}
                  />
                }
              />
            </Drawer>

            <Edit {...props}>
                <SimpleForm
                    warnWhenUnsavedChanges
                    className={classes.formContainer}
                >
                <FormProvider>
                    <EditForm
                        {...props}
                        setFormData={setFormData}
                        // formData={formData}
                        toolbar={<CreateCourseToolbar />}
                    />
                </FormProvider>
                </SimpleForm>
            </Edit>
        </>
    )
}
